import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';
import { PasswordStrengthComponent } from '../../shared/password-strength/password-strength';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   newpass: string;
   oldpass: string;
   conpass: string;
   minLength: number;
   maxLength: number;
   newError: string;
   loading: boolean;
   private username: string;
   private fullname: string;
   visible = false;
   visibleO = false;
   visibleC = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public service: IdexService,
              private dialogRef: MatDialogRef<ChangePasswordComponent>, private toast: Toast,
              private translate: TranslateService) {

     if (data) {
        this.username = data.user.email;
        this.fullname = data.user.name;
     } else {
        this.username = '';
        this.fullname = '';
     }
  }

   ngOnInit(): void {
      this.service.get('api/password-policy')
         .subscribe(data => {
            this.minLength = data.minLength;
            this.maxLength = data.maxLength;
         });
   }

   eval(): void {
      if (this.newpass) {
         this.pwdStrength.eval(this.newpass, this.username, this.fullname);
      }
   }

  changePassword() {
     this.service.changePassword(this.oldpass, this.newpass)
        .subscribe(data => {
           this.translate.get('alert.changepassword').subscribe(s => {
              this.toast.success(s);
           });
           this.dialogRef.close();
        }, error => {
           let e = error;
           try {
              e = JSON.parse(error);
           } catch {}
           if (e.status === 401) {
              this.translate.get('timeout').subscribe(s => {
                 this.toast.error(s);
              });
              this.dialogRef.close();
           } else if (e.status === 403) {
              this.toast.error(e.message);
              this.newError = e.message;
              this.loading = false;
              this.dialogRef.close();
           } else {
              this.toast.error(e.message);
              this.newError = e.message;
              this.loading = false;
           }
        });
  }
}
